import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Header } from "../../../components/header/Header";
import { SketchDetails } from "../../../components/sketch_details/SketchDetails";
import { useDispatch, useSelector } from "react-redux";
import { getContestDetailThunk as onGetContestDetailThunk } from "../../../slices/contest/thunk";
import { getAuthUser } from "../../../utils/GetAuthUser";
import { CountdownTimer } from "../../contest/CountdownTimer";
import ParticipateContest from "./ParticipateContest";
import { SketchResult } from "../../users/uploadimage/create_contest/SketchResult";
import { CommentCheck } from "../../../components/comment/CommentCheck";
import { createSelector } from "@reduxjs/toolkit";
import {
  getContestCommentsThunk as onGetContestComments,
  saveContestCommentsThunk as onSaveContestComments,
} from "../../../slices/comments/thunk";

const contestSelector = (state) => state.contest.contestList;

export const DesignContestDetail = () => {
  const dispatch = useDispatch();
  const { contestId } = useParams();

  const contestList = useSelector(contestSelector);
  const authUser = getAuthUser();
  const currentArtistId = authUser?.user?.id;

  const [contestDetail, setContestDetail] = useState(null);
  const [showParticipateButton, setShowParticipateButton] = useState(false);

  const selectCommentsState = (state) => state.comments;
  const commentsSelector = createSelector(selectCommentsState, (comments) => ({
    comments: comments.comments,
    isLoading: comments.isLoading,
    isSaving: comments.isSaving,
    isCommentSave: comments.isCommentSave,
  }));

  const { comments, isLoading, isSaving, isCommentSave } =
    useSelector(commentsSelector);

  const [sketchData, setSketchData] = useState({
    id: null,
    name: "",
    description: "",
    media: [],
    timeLeft: 0,
  });

  useEffect(() => {
    if (contestId) {
      dispatch(onGetContestDetailThunk({ contestId }));
    }
  }, [dispatch, contestId]);

  useEffect(() => {
    if (!contestList || !contestList.id) return;

    const participants = contestList.participants || [];
    const isAllowStartDesigning = participants.some(
      (p) => p.started_at == null
    );

    setContestDetail(contestList);
    setShowParticipateButton(isAllowStartDesigning);

    setSketchData({
      id: contestList.id || null,
      name: contestList.contestCategory || "",
      description: contestList.contestDescription || "",
      media: contestList.contestMedia || [],
      timeLeft: contestList.timeLeft || 0,
      portalFeePercentage: contestList.portalFeePercentage || 0,
      artistFeePercentage: contestList.artistFeePercentage || 0,
      artistPrize: contestList.artistPrize || 0,
      contestParticipateId: contestList.contestParticipateId || 0,
    });
  }, [contestList, currentArtistId]);

  useEffect(() => {
    if (isCommentSave) {
      dispatch(onGetContestComments({ contest_id: contestId }));
    }
  }, [isCommentSave, dispatch, contestId]);

  const handleSaveComment = (commentData) => {
    dispatch(onSaveContestComments(commentData));
  };

  if (!contestDetail) return null;

  const uploadedResults = contestDetail.uploadedResults || [];
  const uploadedResultForArtist = uploadedResults.find(
    (r) => r.artist_id == currentArtistId
  );


  return (
    <>
      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
        <Header title="Contest" showBack={true} />
      </header>

      <div className="w-full bg-[#F7F7F7]">
        <div className="w-full mx-auto flex flex-col items-start justify-center gap-12 lg:flex-row mt-4">
          
          {/* LEFT SIDE */}
          <div className="w-full lg:w-[40%] flex">
            <SketchDetails
              name={sketchData.name}
              description={sketchData.description}
              sketchMedia={sketchData.media}
              isShowDetail={true}
              isDesignSection={true}
              portalFeeRatio={sketchData.portalFeePercentage}
              artistFeeRatio={sketchData.artistFeePercentage}
              artistPrize={sketchData.artistPrize}
             sketchData={sketchData}
             contestData={contestDetail}


            />
          </div>

          {/* RIGHT SIDE — COMMENT ALWAYS BOTTOM */}
          <div className="w-full lg:w-[60%] min-h-[750px] flex flex-col justify-between">

            {/* TOP CONTENT */}
            <div className="w-full">
              {uploadedResultForArtist ? (
                <SketchResult result={uploadedResultForArtist.file_name} />
              ) : showParticipateButton ? (
                <ParticipateContest
                  description={sketchData.description}
                  contestId={contestId}
                  isStartDesigning={true}
                  contestParticipateId={sketchData.contestParticipateId}
                />
              ) : (
                <div className="cursor-pointer w-full min-h-[500px] h-full flex flex-col items-center justify-center border-2 border-dashed border-border_color rounded-[14px] px-4">
                  <CountdownTimer
                    timeLeft={contestDetail?.timeLeft}
                    contestId={contestId}
                    isFinalResult={1}
                  />
                </div>
              )}
            </div>

            {/* COMMENT SECTION FIXED AT BOTTOM */}
            <div className="mt-auto w-full pt-6">
              <CommentCheck
                contestId={contestId}
                comments={comments}
                isLoading={isLoading}
                isSaving={isSaving}
                onSaveComment={handleSaveComment}
              />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};
